import { API, handleApiError } from "./utils";

export const getUserDetail = async (userId) => {
  try {
    const res = await API.get(`/user-detail/${userId}`);
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getUserDetailWithToken = async (userId, token) => {
  try {
    const res = await API.get(`/user-detail/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

